// extracted by mini-css-extract-plugin
module.exports = {"listingList":"blog_listingList__3BQHt","details":"blog_details__31tMs"};